export function matchesDataActStatusFilter(
  product: { dataActStatus?: string | null | undefined },
  filterValue: string | undefined,
): boolean {
  if (!filterValue) return true;
  if (filterValue === "not_assessed") {
    return !product.dataActStatus || product.dataActStatus === "not_assessed";
  }
  return product.dataActStatus === filterValue;
}
